<template>
  <v-dialog v-model="dialog" eager scrollable persistent>
    <template v-slot:activator="{ on, attrs }" pl-3>
      <v-btn
        v-bind="attrs"
        icon
        :title="$t('entitySelect.createNew')"
        v-on="on"
      >
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
    </template>

    <DeviceFormDialog
      @dialogClosed="handleDialogClosed"
      :visible="dialog"
      v-if="dialog"
      @selectedDevice="sendSelectedDevice"
    />
  </v-dialog>
</template>

<script>
import DeviceFormDialog from '@/views/devices/DeviceFormDialog';

export default {
  name: 'DeviceCreationDialog',

  components: {
    DeviceFormDialog,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    sendSelectedDevice(device) {
      this.$emit('selected', device);
    },

    handleDialogClosed() {
      this.dialog = false;
      this.$emit('dialogClosed');
    },
  },
};
</script>
